export default function testFnc() {
  


console.clear();

function hasSubarrayWithSum(arr, target) {
  for (let i = 0; i < arr.length; i++) {
    let sum = 0;

    for (let j = i; j < arr.length; j++) {
      sum += arr[j];

      if (sum === target) {
        return true;
      }
    }
  }

  return false;
}

console.log(hasSubarrayWithSum([15, 11, 2, 3, 7, 5], 12));


}
